import { defineStore } from 'pinia'
import moment from "moment";

export const CurrentPeriod = defineStore({
    id: 'wp_date_week',
    state: () => {
        return { value: moment().startOf('week') }
    },
    actions: {
        get() {
            return this.value
        },
        set(data) {
            this.value = data.startOf('week')
        }
    },
})
